import httpClient from "./httpClient";

const prefix = "/perceptions";

// Perception Template interfaces
export interface PerceptionTemplate {
  id: string;
  name: string;
  description: string;
  amount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePerceptionTemplateDto {
  name: string;
  description: string;
  amount: number;
}

export interface UpdatePerceptionTemplateDto {
  name?: string;
  description?: string;
  amount?: number;
}

export async function saveIncentive(body: any) {
  return (await httpClient.post(`${prefix}/incentive`, body)).data;
}

export async function findIncentivesByPartner(id: number) {
  return (await httpClient.get(`${prefix}/incentives-partner/${id}`)).data;
}

export async function findIncentiveById(id: string) {
  return (await httpClient.get(`${prefix}/incentive/${id}`)).data;
}

export async function updateIncentive(id: string, body: any) {
  return (await httpClient.put(`${prefix}/incentive/${id}`, body)).data;
}

export async function deleteIncentive(id: string) {
  return (await httpClient.delete(`${prefix}/incentive/${id}`)).data;
}

export async function findActiveIncentives(params?: Record<string, any>) {
  return (
    await httpClient.get(`${prefix}/incentive`, {
      params,
    })
  ).data;
}

// Perception Template functions
export const savePerceptionTemplate = async (
  data: CreatePerceptionTemplateDto
): Promise<PerceptionTemplate> => {
  const response = await httpClient.post("/perceptions/templates", data);
  return response.data;
};

export const findPerceptionTemplates = async (
  searchQuery?: string, 
  limit?: number
): Promise<PerceptionTemplate[]> => {
  const params: any = {};
  
  if (searchQuery && searchQuery.trim().length > 0) {
    params.search = searchQuery.trim();
  }
  
  if (limit && limit > 0) {
    params.limit = limit;
  }
  
  const response = await httpClient.get("/perceptions/templates", { params });
  return response.data;
};

export const findPerceptionTemplate = async (id: string): Promise<PerceptionTemplate> => {
  const response = await httpClient.get(`/perceptions/templates/${id}`);
  return response.data;
};

export const updatePerceptionTemplate = async (
  id: string,
  data: UpdatePerceptionTemplateDto
): Promise<PerceptionTemplate> => {
  const response = await httpClient.put(`/perceptions/templates/${id}`, data);
  return response.data;
};

export const deletePerceptionTemplate = async (
  id: string
): Promise<void> => {
  await httpClient.delete(`/perceptions/templates/${id}`);
};
